module.exports = __webpack_public_path__ + "media/images/flags/16/Spain-09d916ade13db443a33a52d250a8bde1.png";